<template>
     <div v-if="loading" class="loader-container">
    <PulseLoader size="20px" color="#3467D5" />
  </div>
  <div class="container">
    <div class="header">
      <div class="title-bar">
        <!-- <button class="button-bar" @click="back()">Back</button> -->
        <img src="../icons/Content.svg" alt="Renants" />
      </div>
    </div>
    <div class="content-area">
      <div class="left-view">
        <div class="wizard-header">
          <div class="wizard-title-row">
            <span class="NewPost">
              {{ view === "Edit" ? "Edit Post" : "Create New Post" }}
            </span>
            <span class="wizard-count">Step {{ currentStep + 1 }} of {{ steps.length }}</span>
          </div>
          <div class="wizard-progress">
            <button
              v-for="(step, i) in steps"
              :key="step.key"
              type="button"
              class="wizard-seg"
              :class="{ done: i < currentStep, active: i === currentStep }"
              :disabled="!canJumpTo(i)"
              :title="step.label"
              :aria-label="step.label"
              @click="goToStep(i)"
            ></button>
          </div>
          <span class="wizard-step-label">{{ steps[currentStep].label }}</span>
        </div>

        <div class="wizard-body">
          <!-- Step: category -->
          <section v-if="stepKey === 'service'" class="wizard-panel">
            <div class="panel-heading">
              <span class="panel-title">What are you posting?</span>
              <span class="post-detail">This decides which details we ask for next.</span>
            </div>
            <div class="cat-grid">
              <button
                v-for="main in servicetypes1"
                :key="main"
                type="button"
                class="cat-card"
                :class="{ active: activeMain === main.trim() }"
                @click="pickMain(main)"
              >
                <svg v-if="main.trim() === 'Rentals'" class="cat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" stroke-width="2"/>
                </svg>
                <svg v-else-if="main.trim() === 'Services'" class="cat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else-if="main.trim() === 'Jobs'" class="cat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" stroke="currentColor" stroke-width="2"/>
                  <rect width="20" height="14" x="2" y="6" rx="2" stroke="currentColor" stroke-width="2"/>
                </svg>
                <svg v-else-if="main.trim() === 'Sale'" class="cat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="8" cy="21" r="1" stroke="currentColor" stroke-width="2"/>
                  <circle cx="19" cy="21" r="1" stroke="currentColor" stroke-width="2"/>
                  <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else-if="main.trim() === 'Events'" class="cat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M8 2v4M16 2v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <rect width="18" height="18" x="3" y="4" rx="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M3 10h18" stroke="currentColor" stroke-width="2"/>
                </svg>
                <svg v-else class="cat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span class="cat-card-name">{{ main }}</span>
              </button>
            </div>
            <div v-if="activeSubtypes.length" class="sub-block">
              <span class="choose-name">Pick a subtype</span>
              <div class="sub-chips">
                <button
                  v-for="sub in activeSubtypes"
                  :key="sub.name"
                  type="button"
                  class="sub-chip"
                  :class="{ active: form.serviceType1 === activeMain && form.serviceType2 === sub.name }"
                  @click="selectSubCategory(activeMain, sub.name)"
                >
                  {{ sub.name }}
                </button>
              </div>
            </div>
            <!-- 3rd-level property type (serviceTypeInfo) — only shown when the
                 chosen subtype has a Service_type3 mapping, e.g. Real Estate ›
                 Residential Properties › Single Family Homes. Bound to
                 form.serviceType, which the composable saves as serviceTypeInfo. -->
            <div v-if="activeLeaves.length" class="sub-block">
              <span class="choose-name">Pick a property type <span class="optional-hint">(optional)</span></span>
              <div class="sub-chips">
                <button
                  v-for="leaf in activeLeaves"
                  :key="leaf"
                  type="button"
                  class="sub-chip"
                  :class="{ active: form.serviceType === leaf }"
                  @click="selectLeaf(leaf)"
                >
                  {{ leaf }}
                </button>
              </div>
            </div>
            <span class="field-error" v-if="errors.serviceType">
              Choose a category and subtype to continue.
            </span>
            <!-- Service Type Input (custom) -->
            <div class="title-section" v-if="showServiceTypeInput">
              <span class="title-name">{{ getFieldLabel('serviceTypeInput') }}</span>
              <span class="input-box">
                <input
                  class="input-text"
                  type="text"
                  placeholder="Enter Service Type..."
                  v-model="form.serviceType"
                />
              </span>
            </div>
          </section>

          <!-- Step: details -->
          <section v-else-if="stepKey === 'details'" class="wizard-panel">
          <div class="panel-heading">
            <span class="panel-title">Describe your listing</span>
            <span class="post-detail">A clear title and description help people find your post.</span>
          </div>
          <!-- Title -->
          <div class="title-section" v-if="shouldShowField('title')">
            <span class="title-name">{{ getFieldLabel('title') }}</span>
            <span class="input-box" :class="{ 'error-outline': errors.title }">
              <input
                class="input-text"
                type="text"
                placeholder="Enter title here..."
                v-model="form.title"
              />
            </span>
          </div>
          <!-- Description -->
          <div class="dec-section" v-if="shouldShowField('description')">
            <span class="desc-data">{{ getFieldLabel('description') }}</span>
            <span class="desc-box">
              <textarea
                class="desc-text"
                type="text"
                placeholder="Write the Description of the posting"
                v-model="form.description"
              ></textarea>
            </span>
          </div>
          <!-- Price -->
          <div class="title-section" v-if="shouldShowField('roomPrice')">
            <span class="title-name">{{ getFieldLabel('roomPrice') }}</span>
            <span class="input-box">
              <input
                class="input-text"
                type="text"
                :placeholder="getFieldLabel('roomPrice') + '...'"
                v-model="form.roomPrice"
                  @input="form.roomPrice = form.roomPrice.replace(/[^0-9]/g, '')"
              />
            </span>
          </div>
          </section>

          <!-- Step: location & contact -->
          <section v-else-if="stepKey === 'contact'" class="wizard-panel">
          <div class="panel-heading">
            <span class="panel-title">Where and how to reach you</span>
            <span class="post-detail">People nearby see your post first, and reply using these details.</span>
          </div>
          <!-- Service Providing Location -->
          <div class="search-type" v-if="shouldShowField('location')">
            <span class="search-name">{{ getFieldLabel('location') }}</span>

            <div class="search-box" ref="locationBox">
              <img src="../icons/search.svg" class="search-icon" />

              <input
                class="search-text"
                type="text"
                placeholder="Search Location"
                v-model="searchQuery"
                @input="onInputChange"
                @focus="showSuggestions = true"
              />
              <ul v-if="showSuggestions && suggestions.length" class="suggestion-list">
                <li
                  v-for="(place, index) in suggestions"
                  :key="place.place_id || place.description || index"
                  @mouseover="hoverIndex = index"
                  @mouseleave="hoverIndex = null"
                  @click="selectSuggestion(place)"
                  :class="{ highlighted: index === hoverIndex }"
                >
                  <div class="suggestion-item">
                    <i class="fas fa-map-marker-alt location-icon"></i>
                    <span class="place-text">{{ place.description }}</span>
                    <i
                      v-if="isSelectedPlace(place)"
                      class="fas fa-check check-icon"
                    ></i>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- Contact Details -->
          <div class="contact-details" v-if="shouldShowField('contact')">
            <div class="mobile" v-if="shouldShowField('phoneNumber')">
              <span class="mobile-label">{{ getFieldLabel('phoneNumber') }}</span>
              <div
                class="contact-input"
                :class="{ 'error-outline': errors.phone }"
              >
                <!-- Country code dropdown (custom) -->
                <div class="country-code-wrapper" ref="countryDropdownRef">
                  <button
                    type="button"
                    class="country-code-btn"
                    @click="showCountryDropdown = !showCountryDropdown"
                    :aria-expanded="showCountryDropdown"
                    aria-label="Country code"
                  >
                    <span class="cc-dial">{{ form.countryCode || '+1' }}</span>
                    <svg class="cc-chevron" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <ul v-if="showCountryDropdown" class="country-code-list" role="listbox">
                    <li
                      v-for="country in countries"
                      :key="country.code"
                      class="country-code-item"
                      :class="{ active: country.dial_code === form.countryCode }"
                      role="option"
                      :aria-selected="country.dial_code === form.countryCode"
                      @click="selectCountry(country)"
                    >
                      <span class="cc-item-dial">{{ country.dial_code }}</span>
                      <span class="cc-item-name">{{ country.name }}</span>
                    </li>
                  </ul>
                </div>

                <!-- Phone number input -->
                <input
                  type="tel"
                  inputmode="numeric"
                  v-model="form.phoneNumber"
                  placeholder="Enter Mobile Number"
                  class="contact-text"
                  maxlength="10"
                  @keypress="onPhoneKeypress"
                  @paste="onPhonePaste"
                  @input="onPhoneInput"
                />
              </div>
              <span class="field-error" v-if="errors.phone && phoneErrorMessage">
                {{ phoneErrorMessage }}
              </span>
            </div>

            <div class="email" v-if="shouldShowField('email')">
              <span class="email-label">{{ getFieldLabel('email') }}</span>
              <input
                class="email-text"
                type="text"
                placeholder="Enter Email ID"
                v-model="form.email"
              />
            </div>
          </div>
          </section>

          <!-- Step: photos -->
          <section v-else-if="stepKey === 'photos'" class="wizard-panel">
          <div class="panel-heading">
            <span class="panel-title">Add photos</span>
            <span class="post-detail">Listings with photos get more responses. You can skip this and add them later.</span>
          </div>
          <!-- Images -->
          <div class="images-details" v-if="shouldShowField('images')">
            <span class="images-name">{{ getFieldLabel('images') }}</span>
            <!-- Upload Box -->
            <div
              class="images-box"
              :class="{ 'has-images': previewImages.length > 0 }"
              @dragover.prevent
              @drop.prevent="handleDrop"
              @click="
                previewImages.length === 0 ? $refs.fileInput.click() : null
              "
            >
              <img
                v-if="!previewImages.length"
                src="../icons/Featured icon.svg"
                class="upload-icon"
              />

              <span v-if="!previewImages.length" class="first-row">
                <span class="click-text">Click to upload</span>
                <span class="or-text">or drag and drop</span>
              </span>
              <span v-if="!previewImages.length" class="hint-text"
                >SVG, PNG, JPG or GIF (max. {{ isAdmin ? 'unlimited' : imageLimit }} images)</span
              >
              <div v-if="previewImages.length" class="preview-container">
                <div
                  v-for="(img, index) in previewImages"
                  :key="index"
                  class="thumb position-relative"
                >
                  <img :src="img" alt="Preview" />
                  <button class="remove-btn" @click.stop="removeImage(index)">
                    ×
                  </button>
                </div>
                <div
                  v-if="previewImages.length < imageLimit"
                  class="thumb add-more"
                  @click.stop="$refs.fileInput.click()"
                >
                  +
                </div>
              </div>
            </div>

            <input
              type="file"
              ref="fileInput"
              multiple
              accept="image/*"
              @change="handleFileSelect"
              style="display: none"
            />
          </div>
          </section>

          <!-- Step: review & publish -->
          <section v-else class="wizard-panel">
            <div class="panel-heading">
              <span class="panel-title">Review your post</span>
              <span class="post-detail">
                Make sure everything looks right, then
                {{ view === "Edit" ? "save your changes" : "publish" }}.
              </span>
            </div>
            <div class="review-list">
              <div class="review-row" v-for="row in reviewRows" :key="row.key">
                <div class="review-info">
                  <span class="review-label">{{ row.label }}</span>
                  <span class="review-value" :class="{ empty: !row.value }">
                    {{ row.value || "Not added" }}
                  </span>
                </div>
                <button type="button" class="review-edit" @click="goToStep(row.step)">
                  Edit
                </button>
              </div>
            </div>
          </section>
        </div>

        <div class="wizard-footer">
          <button
            type="button"
            class="wizard-back"
            :class="{ hidden: currentStep === 0 }"
            @click="prevStep"
          >
            Back
          </button>
          <div class="wizard-footer-right">
            <button
              v-if="steps[currentStep].optional && !isLastStep"
              type="button"
              class="wizard-skip"
              @click="skipStep"
            >
              Skip for now
            </button>
            <button v-if="!isLastStep" type="button" class="wizard-continue" @click="nextStep">
              Continue
            </button>
            <button v-else type="button" class="wizard-continue" @click="submitForm" :disabled="loading">
              {{ loading ? "Publishing..." : (view === "Edit" ? "Save Post" : "Publish Post") }}
            </button>
          </div>
        </div>
      </div>
      <RightViewCard :formData="form" />
    </div>

    <!-- Pricing modal: shows as upsell after post success or when limit reached -->
    <PricingModal
      v-if="showPricingModal"
      :mode="pricingModalMode"
      :postsLimit="pricingPostsLimit"
      @close="handlePricingClose"
    />
  </div>
</template>
<script>
import RightViewCard from "../pages/NewPostSection.vue";
import PricingModal from "./Models/PricingModal.vue";
import { UsePostEdit } from "@/services/UsePostEditPages";
import { ref, onMounted, onBeforeUnmount, computed, watch, nextTick } from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { trackEvent } from "@/composables/useAnalytics";
import { useSubscription, fetchSubscriptionStatus } from "@/composables/useSubscription";

export default {
  name: "NewPost",
  props: {
    view: { type: String, default: "Post" },
    serviceId: { type: String, default: null },
  },
  components: { RightViewCard, PulseLoader, PricingModal },
  setup(props) {
    const NewPost = UsePostEdit(props.view, props.serviceId);
    const errors = ref({
      title: false,
      serviceType: false,
      phone: false,
    });
    // Phone number must be exactly 10 numeric digits (national number; the
    // country code is selected separately). phoneErrorMessage holds the message
    // shown under the field when validation fails.
    const PHONE_DIGIT_COUNT = 10;
    const phoneErrorMessage = ref("");
    function getPhoneError(rawPhone) {
      const digits = String(rawPhone || "").replace(/\D/g, "");
      if (!digits) return "Phone number is required.";
      if (digits.length !== PHONE_DIGIT_COUNT) {
        return `Phone number must be exactly ${PHONE_DIGIT_COUNT} digits.`;
      }
      return "";
    }
    const showPricingModal = ref(false);
    const pricingModalMode = ref("upsell");
    const pricingPostsLimit = ref(5);
    const { isFree } = useSubscription();
    const selectedMain = ref(null);
    const currentStep = ref(0);
    const maxVisited = ref(0);
    const locationBox = ref(null);
    const showSuggestions = ref(false);
    const activeFields = ref([]);
    const fieldVisibility = ref({});
      // Use loading from UsePostEdit
      const loading = NewPost.loading;

    // Country code dropdown state
    const showCountryDropdown = ref(false);
    const countryDropdownRef = ref(null);
    function selectCountry(country) {
      NewPost.form.countryCode = country.dial_code;
      showCountryDropdown.value = false;
    }
    function handleCountryClickOutside(event) {
      if (
        countryDropdownRef.value &&
        !countryDropdownRef.value.contains(event.target)
      ) {
        showCountryDropdown.value = false;
      }
    }

    // Hide location suggestions when clicking outside
    function handleLocationClickOutside(event) {
      if (locationBox.value && !locationBox.value.contains(event.target)) {
        showSuggestions.value = false;
      }
    }

    onMounted(() => {
      document.addEventListener("click", handleCountryClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleLocationClickOutside);
      document.removeEventListener("click", handleCountryClickOutside);
    });

    // New: service types structure
    const servicetypes1 = ref([]);
    const servicetypes2Map = ref({});
    const servicetypes3Map = ref({}); // 3rd-level leaves per subtype (property types)
    const fieldsToShow = ref(null); // fields to show for selected subtype

    // Fetch service types from backend
    onMounted(async () => {
     document.addEventListener("click", handleLocationClickOutside);
      const savedLocation = localStorage.getItem("userLocation");
      if (savedLocation) {
        const locationObj = JSON.parse(savedLocation);
        NewPost.searchQuery.value = locationObj.fullAddress;
        NewPost.form.location = locationObj.fullAddress;
      }
      try {
        console.log("Fetching /api/servicetypes ...");
        const { data } = await (NewPost.axios && NewPost.axios.get
          ? NewPost.axios.get('/api/servicetypes')
          : import('axios').then(ax => ax.default.get('/api/servicetypes')));
        console.log("API /api/servicetypes response:", data);
        servicetypes1.value = data.servicetypes1 || [];
        // Use Object.assign to preserve reactivity
        Object.assign(servicetypes2Map.value, data.servicetypes2Map || {});
        Object.assign(servicetypes3Map.value, data.servicetypes3Map || {});
        console.log("servicetypes1:", servicetypes1.value);
        console.log("servicetypes2Map:", servicetypes2Map.value);
      } catch (e) {
        console.error("Error fetching service types:", e);
        servicetypes1.value = [];
        servicetypes2Map.value = {};
        servicetypes3Map.value = {};
      }
      loading.value = false; // <-- FIX: set loading to false after all async logic
      // --- PATCH: On Edit, set fieldVisibility for current serviceType1/2 ---
      if (
        props.view === "Edit" &&
        NewPost.form.serviceType1 &&
        NewPost.form.serviceType2
      ) {
        // Wait for servicetypes2Map to be populated
        await nextTick();
        setFieldVisibilityForEdit();
        landOnReviewForEdit();
      }
    });

    // Editing starts on the review step with every step unlocked, so a
    // one-field change doesn't require walking the whole wizard. The post
    // data loads async, so this fires from whichever runs last: the
    // servicetypes fetch above or the serviceType1/2 watcher below.
    let editReviewShown = false;
    function landOnReviewForEdit() {
      if (props.view !== "Edit" || editReviewShown) return;
      editReviewShown = true;
      currentStep.value = steps.value.length - 1;
      maxVisited.value = steps.value.length - 1;
    }

    // --- PATCH: Helper to set fieldVisibility for Edit mode ---
    function setFieldVisibilityForEdit() {
      const main = NewPost.form.serviceType1;
      const sub = NewPost.form.serviceType2;
      const subtypeObj = servicetypes2Map.value[main]?.find(
        item => item.name === sub
      );
      fieldVisibility.value = {};
      if (subtypeObj?.fields) {
        subtypeObj.fields.forEach(f => {
          fieldVisibility.value[f.key] = f.show !== false;
        });
      }
    }

    // --- PATCH: Also update fieldVisibility if user changes serviceType1/2 manually in Edit ---
    watch(
      [() => NewPost.form.serviceType1, () => NewPost.form.serviceType2],
      ([main, sub]) => {
        if (main && sub) {
          setFieldVisibilityForEdit();
          landOnReviewForEdit();
        }
      }
    );

const selectSubCategory = (main, sub) => {
  // serviceType (== serviceTypeInfo) is scoped to a specific subtype — it holds
  // either a Real-Estate property-type leaf or the Services/Sale/Events free
  // text. Switching to a different subtype must clear it so it can't leak
  // across (e.g. "Single Family Homes" bleeding into a Services free-text box).
  const subtypeChanged =
    NewPost.form.serviceType1 !== main || NewPost.form.serviceType2 !== sub;

  NewPost.form.serviceType1 = main;
  NewPost.form.serviceType2 = sub;
  errors.value.serviceType = false;

  if (subtypeChanged) {
    NewPost.form.serviceType = "";
  }

  const subtypeObj = servicetypes2Map.value[main]?.find(
    item => item.name === sub
  );

  fieldVisibility.value = {};

  if (subtypeObj?.fields) {
    subtypeObj.fields.forEach(f => {
      // hide ONLY when show === false
      fieldVisibility.value[f.key] = f.show !== false;
    });
  }
};

const pickMain = (main) => {
  selectedMain.value = main.trim();
};

const activeMain = computed(
  () => selectedMain.value || NewPost.form.serviceType1 || ""
);
const activeSubtypes = computed(
  () => servicetypes2Map.value[activeMain.value] || []
);
// 3rd-level leaves for the currently-selected subtype (e.g. Single Family
// Homes…). Empty for subtypes with no mapping — the picker then stays hidden.
const activeLeaves = computed(() => {
  const map = servicetypes3Map.value[activeMain.value];
  const sub = NewPost.form.serviceType2;
  return (map && Array.isArray(map[sub])) ? map[sub] : [];
});
const selectLeaf = (leaf) => {
  // Toggle off when re-clicking the active leaf (property type is optional).
  NewPost.form.serviceType = NewPost.form.serviceType === leaf ? "" : leaf;
};


function shouldShowField(field) {
  // No subtype selected → show everything
  if (!Object.keys(fieldVisibility.value).length) return true;

  const fieldMap = {
    title: "title",
    description: "description",
    location: "location",
    roomPrice: "roomPrice",
    phoneNumber: "phoneNumber",
    email: "email",
    images: "photo",
  };

  // Contact group
  if (field === "contact") {
    return (
      fieldVisibility.value.phoneNumber !== false ||
      fieldVisibility.value.email !== false
    );
  }

  const backendKey = fieldMap[field] || field;

  // Default = SHOW unless explicitly false
  return fieldVisibility.value[backendKey] !== false;
}

    // ── Wizard steps ──────────────────────────────────────────────
    // Steps are derived from the subtype's field visibility, so a subtype
    // that hides e.g. photos simply drops that step from the flow.
    const steps = computed(() => {
      const s = [{ key: "service", label: "Category" }];
      if (
        shouldShowField("title") ||
        shouldShowField("description") ||
        shouldShowField("roomPrice")
      ) {
        s.push({ key: "details", label: "Details" });
      }
      if (shouldShowField("location") || shouldShowField("contact")) {
        s.push({ key: "contact", label: "Location & contact" });
      }
      if (shouldShowField("images")) {
        s.push({ key: "photos", label: "Photos", optional: true });
      }
      s.push({ key: "review", label: "Review & publish" });
      return s;
    });

    const stepKey = computed(() => steps.value[currentStep.value]?.key || "service");
    const isLastStep = computed(() => currentStep.value === steps.value.length - 1);

    // Changing subtype can shrink the step list — keep indexes in range.
    watch(
      () => steps.value.length,
      (len) => {
        if (currentStep.value > len - 1) currentStep.value = len - 1;
        if (maxVisited.value > len - 1) maxVisited.value = len - 1;
      }
    );

    function stepIndexOf(key) {
      const i = steps.value.findIndex((s) => s.key === key);
      return i === -1 ? 0 : i;
    }

    // Edit mode unlocks every step (the post already has valid data);
    // new posts can only jump back to steps they've already passed.
    function canJumpTo(i) {
      return props.view === "Edit" || i <= maxVisited.value;
    }

    function goToStep(i) {
      if (canJumpTo(i)) currentStep.value = i;
    }

    function validateStep(key) {
      if (key === "service") {
        errors.value.serviceType = !(
          NewPost.form.serviceType1 && NewPost.form.serviceType2
        );
        return !errors.value.serviceType;
      }
      if (key === "details") {
        errors.value.title = shouldShowField("title") && !NewPost.form.title?.trim();
        return !errors.value.title;
      }
      if (key === "contact" && shouldShowField("phoneNumber")) {
        phoneErrorMessage.value = getPhoneError(NewPost.form.phoneNumber);
        errors.value.phone = !!phoneErrorMessage.value;
        return !errors.value.phone;
      }
      return true;
    }

    function nextStep() {
      if (!validateStep(stepKey.value)) return;
      if (!isLastStep.value) {
        currentStep.value++;
        if (currentStep.value > maxVisited.value) maxVisited.value = currentStep.value;
      }
    }

    function prevStep() {
      if (currentStep.value > 0) currentStep.value--;
    }

    function skipStep() {
      if (!isLastStep.value) {
        currentStep.value++;
        if (currentStep.value > maxVisited.value) maxVisited.value = currentStep.value;
      }
    }

    const reviewRows = computed(() => {
      const rows = [
        {
          key: "service",
          label: "Category",
          value:
            NewPost.form.serviceType1 && NewPost.form.serviceType2
              ? NewPost.form.serviceType1 + " — " + NewPost.form.serviceType2
              : "",
          step: stepIndexOf("service"),
        },
      ];
      if (shouldShowField("title")) {
        rows.push({
          key: "title",
          label: getFieldLabel("title"),
          value: NewPost.form.title,
          step: stepIndexOf("details"),
        });
      }
      if (shouldShowField("roomPrice")) {
        rows.push({
          key: "price",
          label: getFieldLabel("roomPrice"),
          value: NewPost.form.roomPrice,
          step: stepIndexOf("details"),
        });
      }
      if (shouldShowField("location")) {
        rows.push({
          key: "location",
          label: "Location",
          value: NewPost.form.location,
          step: stepIndexOf("contact"),
        });
      }
      if (shouldShowField("phoneNumber")) {
        rows.push({
          key: "phone",
          label: getFieldLabel("phoneNumber"),
          value: NewPost.form.phoneNumber
            ? (NewPost.form.countryCode || "+1") + " " + NewPost.form.phoneNumber
            : "",
          step: stepIndexOf("contact"),
        });
      }
      if (shouldShowField("email")) {
        rows.push({
          key: "email",
          label: getFieldLabel("email"),
          value: NewPost.form.email,
          step: stepIndexOf("contact"),
        });
      }
      if (shouldShowField("images")) {
        const n = NewPost.previewImages.value.length;
        rows.push({
          key: "photos",
          label: "Photos",
          value: n ? n + (n === 1 ? " photo" : " photos") : "",
          step: stepIndexOf("photos"),
        });
      }
      return rows;
    });



    const showServiceTypeInput = computed(() => {
      // Only show if main type is Services, Sale, or Events AND a subtype is selected
      return ["Services", "Sale", "Events"].includes(NewPost.form.serviceType1) && !!NewPost.form.serviceType2;
    });

    // const submitForm = async () => {
    //   loading.value = true;
    //   errors.value.title = !(NewPost.form.title?.trim());
    //   errors.value.serviceType = !(
    //     NewPost.form.serviceType1 && NewPost.form.serviceType2
    //   );
    //   errors.value.phone = !(NewPost.form.phoneNumber?.trim());
    //   if (
    //     errors.value.title ||
    //     errors.value.serviceType ||
    //     errors.value.phone
    //   ) {
    //     loading.value = false;
    //     return;
    //   }
    //   try {
    //     await NewPost.submitForm();
    //   } catch (e) {
    //     // Optionally handle error
    //   } finally {
    //     loading.value = false;
    //   }
    // };
const submitForm = async () => {
  errors.value.title = !(NewPost.form.title?.trim());
  errors.value.serviceType = !(NewPost.form.serviceType1 && NewPost.form.serviceType2);
  phoneErrorMessage.value = getPhoneError(NewPost.form.phoneNumber);
  errors.value.phone = !!phoneErrorMessage.value;

  if (
    errors.value.title ||
    errors.value.serviceType ||
    errors.value.phone
  ) {
    // Jump to the step that owns the first failing field so the error is visible.
    if (errors.value.serviceType) currentStep.value = stepIndexOf("service");
    else if (errors.value.title) currentStep.value = stepIndexOf("details");
    else currentStep.value = stepIndexOf("contact");
    return;
  }

  trackEvent(props.view === 'Edit' ? 'edit_post' : 'create_post', {
    category: NewPost.form.serviceType1 || '',
    sub_type: NewPost.form.serviceType2 || '',
  });

  try {
    await NewPost.submitForm();

    // Post created successfully — decide flow based on user's plan
    if (props.view !== 'Edit' && isFree.value && NewPost.postRedirectUrl.value) {
      // Free user + new post → show upsell modal, defer redirect until user dismisses
      pricingModalMode.value = "upsell";
      showPricingModal.value = true;
    } else if (NewPost.postRedirectUrl.value) {
      // Paid user or edit → redirect immediately
      window.location.replace(NewPost.postRedirectUrl.value);
    }
  } catch (err) {
    // Handle plan limit reached (403 from checkPostLimit or checkImageLimit middleware)
    if (err?.response?.status === 403 && err?.response?.data?.error === 'POST_LIMIT_REACHED') {
      pricingModalMode.value = "limit";
      pricingPostsLimit.value = err.response.data.postsLimit || 5;
      showPricingModal.value = true;
      return;
    }
    if (err?.response?.status === 403 && err?.response?.data?.error === 'IMAGE_LIMIT_REACHED') {
      pricingModalMode.value = "limit";
      showPricingModal.value = true;
      return;
    }
    // Other errors are handled inside NewPost.submitForm's own catch
  }
};

// When user dismisses the pricing modal, redirect to the post if available
const handlePricingClose = () => {
  showPricingModal.value = false;
  if (NewPost.postRedirectUrl.value) {
    window.location.replace(NewPost.postRedirectUrl.value);
  }
};

    watch(
      () => NewPost.form.serviceType1,
      () => {
        if (!showServiceTypeInput.value) {
          NewPost.form.serviceType = "";
        }
      }
    );

    // Dynamic field label logic
    function getFieldLabel(field) {
      // Find selected subtype object
      const main = NewPost.form.serviceType1;
      const sub = NewPost.form.serviceType2;
      const subtypeObj = servicetypes2Map.value[main]?.find(
        s => s.name === sub
      );
      // If subtypeObj.fields contains a custom label for this field, use it
      if (subtypeObj && subtypeObj.fields) {
        const found = subtypeObj.fields.find(f => f.key === field);
        if (found && found.label) return found.label;
      }
      // Default labels fallback
      const defaultLabels = {
        title: "Title",
        description: "Description",
        serviceTypeInput: "Service Type",
        location: "Service Providing Location",
        roomPrice: "Price",
        phoneNumber: "Mobile Number",
        email: "Email ID",
        images: "Photos",
      };
      return defaultLabels[field] || field;
    }

    function onPhoneKeypress(e) {
      // Allow only digits; block +, -, *, #, spaces, letters, etc.
      const char = e.key;
      if (char.length === 1 && !/[0-9]/.test(char)) {
        e.preventDefault();
      }
    }

    function onPhonePaste(e) {
      e.preventDefault();
      const text = (e.clipboardData || window.clipboardData).getData("text") || "";
      const digits = text.replace(/[^0-9]/g, "").slice(0, 10);
      const current = NewPost.form.phoneNumber || "";
      NewPost.form.phoneNumber = (current + digits).slice(0, 10);
    }

    // Strip any non-digit and, once a validation error is showing, re-validate
    // live so the message clears as soon as the user enters a valid number.
    function onPhoneInput() {
      NewPost.form.phoneNumber = (NewPost.form.phoneNumber || "").replace(/[^0-9]/g, "");
      if (errors.value.phone) {
        phoneErrorMessage.value = getPhoneError(NewPost.form.phoneNumber);
        errors.value.phone = !!phoneErrorMessage.value;
      }
    }

    return {
      ...NewPost,
      view: props.view,
      servicetypes1,
      servicetypes2Map,
      servicetypes3Map,
      pickMain,
      activeMain,
      activeSubtypes,
      activeLeaves,
      selectLeaf,
      currentStep,
      steps,
      stepKey,
      isLastStep,
      canJumpTo,
      goToStep,
      nextStep,
      prevStep,
      skipStep,
      reviewRows,
      selectSubCategory,
      errors,
      submitForm,
      handlePricingClose,
      showPricingModal,
      pricingModalMode,
      pricingPostsLimit,
      showServiceTypeInput,
      shouldShowField,
      getFieldLabel,
      locationBox,
      showSuggestions,
      onPhoneKeypress,
      onPhonePaste,
      onPhoneInput,
      phoneErrorMessage,
      showCountryDropdown,
      countryDropdownRef,
      selectCountry,
    };
  },
};
</script>

<style scoped>
 .loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.container {
  /* Desktop - 5 */

  position: relative;
  width: 100%;
  max-width: 1440px;
  height: 100%;
  display: flex;
  flex-direction: column;

  background: var(--color-bg-primary);
}
.header {
  width: 100%;
  max-width: 1440px;
  height: 80px;
  background: var(--color-bg-primary);
  /* border-bottom: 1px solid var(--color-bg-secondary); */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0 40px;
}

.title-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  width: 100%;
  max-width: 1280px;
  height: 44px;
}
.button-bar {
  /* _Button base */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 18px;
  gap: 8px;
  color: var(--color-text-primary);
  width: 125px;
  height: 44px;

  border: 1px solid var(--color-border-primary);
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
}

.title-bar img {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.content-area {
  width: 100%;
  max-width: 1280px;
  display: flex;
  gap: 6px;
  margin: 0 auto;
  padding: 40px 0;
  padding-top: 0px;
  padding-bottom: 0px;
  flex: 1;
  min-height: 0;
  /* Bound the row to the viewport (minus the 80px header) so the form panel
     scrolls inside .left-view instead of the whole window. Without an explicit
     height here, .left-view's `height: 100%` collapses (ancestors use
     min-height, not height), overflow-y never activates, and the entire tall
     page scrolls — a large repaint area that feels sluggish. */
  height: calc(100vh - 80px);
  overflow: hidden;
}

.left-view {
  width: 100%;
  max-width: 640px;
  height: 100%;
  border-radius: 8px;
  background: var(--color-bg-primary);
  border: 3px solid var(--color-bg-secondary);
  display: flex;
  flex-direction: column;
  /* Steps fit the viewport; only .wizard-body scrolls if a step overflows. */
  overflow: hidden;
}
.right-view {
  width:100%;
  width: 640px;
  height: 100%;
  border-radius: 8px;
  background: var(--color-bg-secondary);
  border: 3px solid var(--color-bg-secondary);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ── Wizard chrome ─────────────────────────────────────────────── */
.wizard-header {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 24px 14px;
  border-bottom: 1px solid var(--color-border-primary);
  background: var(--color-bg-primary);
}
.wizard-title-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}
.wizard-title-row .NewPost {
  width: auto;
  height: auto;
  font-size: 20px;
  line-height: 28px;
  text-align: left;
}
.wizard-count {
  font-family: var(--font-primary);
  font-size: 12px;
  color: var(--color-text-secondary);
  white-space: nowrap;
}
.wizard-progress {
  display: flex;
  gap: 6px;
}
.wizard-seg {
  flex: 1;
  height: 4px;
  border: none;
  border-radius: 2px;
  padding: 0;
  background: var(--color-bg-secondary);
  cursor: pointer;
  transition: background 0.2s ease;
}
.wizard-seg.done,
.wizard-seg.active {
  background: var(--color-primary);
}
.wizard-seg:disabled {
  cursor: default;
}
.wizard-step-label {
  font-family: var(--font-primary);
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-secondary);
}
.wizard-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  -webkit-overflow-scrolling: touch;
}
.wizard-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 592px;
  margin: 0 auto;
}
.panel-heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.panel-title {
  font-family: var(--font-primary);
  font-weight: 600;
  font-size: 17px;
  line-height: 24px;
  color: var(--color-text-primary);
}
.panel-heading .post-detail {
  width: 100%;
  height: auto;
}

/* Category cards */
.cat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 10px;
  width: 100%;
}
.cat-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 14px;
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  border-radius: 10px;
  cursor: pointer;
  color: var(--color-text-secondary);
  transition: border-color 0.15s ease, background 0.15s ease;
}
.cat-card:hover {
  border-color: var(--color-primary);
}
.cat-card.active {
  /* 1px extra border compensated by 1px less padding so cards don't shift */
  border: 2px solid var(--color-primary);
  padding: 13px;
  background: #f5f8ff;
  color: var(--color-primary);
}
.cat-card-name {
  font-family: var(--font-primary);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}
.cat-icon {
  flex-shrink: 0;
}

/* Subtype chips */
.sub-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.sub-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.sub-chip {
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid var(--color-border-primary);
  background: var(--color-bg-primary);
  font-family: var(--font-primary);
  font-size: 13px;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}
.sub-chip:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
}
.sub-chip.active {
  border-color: var(--color-primary);
  background: var(--color-primary);
  color: var(--color-text-inverse);
  font-weight: 500;
}

/* Review step */
.review-list {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border-primary);
  border-radius: 10px;
  overflow: hidden;
}
.review-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
}
.review-row + .review-row {
  border-top: 1px solid var(--color-border-primary);
}
.review-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.review-label {
  font-family: var(--font-primary);
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
}
.review-value {
  font-family: var(--font-primary);
  font-size: 14px;
  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.review-value.empty {
  color: #a0a3a7;
  font-style: italic;
}
.review-edit {
  flex: 0 0 auto;
  border: none;
  background: transparent;
  padding: 6px 8px;
  border-radius: 6px;
  font-family: var(--font-primary);
  font-size: 13px;
  font-weight: 500;
  color: var(--color-primary);
  cursor: pointer;
}
.review-edit:hover {
  background: #f1f4ff;
}

/* Footer */
.wizard-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 24px;
  border-top: 1px solid var(--color-border-primary);
  background: var(--color-bg-primary);
}
.wizard-back {
  display: flex;
  align-items: center;
  padding: 10px 18px;
  border: 1px solid var(--color-border-primary);
  border-radius: 8px;
  background: var(--color-bg-primary);
  font-family: var(--font-primary);
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-secondary);
  cursor: pointer;
}
.wizard-back.hidden {
  visibility: hidden;
}
.wizard-footer-right {
  display: flex;
  align-items: center;
  gap: 14px;
}
.wizard-skip {
  border: none;
  background: transparent;
  font-family: var(--font-primary);
  font-size: 14px;
  color: var(--color-text-secondary);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.wizard-skip:hover {
  color: var(--color-text-primary);
}
.wizard-continue {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  padding: 0 24px;
  background: linear-gradient(180deg, var(--color-primary) 0%, #2f5cc5 100%);
  border: 1px solid var(--color-primary);
  box-shadow: 0 6px 14px rgba(34, 76, 170, 0.22), 0 1px 2px rgba(10, 13, 18, 0.08);
  border-radius: 8px;
  cursor: pointer;
  font-family: var(--font-primary);
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.2px;
  color: var(--color-text-inverse);
  transition: transform 0.12s ease, filter 0.2s ease;
}
.wizard-continue:hover {
  filter: brightness(1.03);
}
.wizard-continue:active {
  transform: translateY(1px);
}
.post-initial {
  /* Text and supporting text */

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  width: 592px;
  height: 76px;
}
.NewPost {
  /* Text */
  display: flex;
  width: 230px;
  height: 32px;
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin-left: 0px;
  /* Gray/900 */
  color: var(--color-text-primary);
}
.post-detail {
  /* Supporting text */

  width: 592px;
  height: 40px;

  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  /* Gray/600 */
  color: var(--color-text-secondary);
}
.title-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  max-width:592px ;
  width:100% ;
  height: 70px;
}
.title-name {
  /* Label */

  width: 100px;
  height: 20px;
  gap: 10px;
  /* Text sm/Medium */
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-secondary);
}
.input-box {
  /* Input */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 14px;
max-width:592px;
  width: 100%;
  height: 44px;

  /* White */
  background: var(--color-bg-primary);
  /* Gray/300 */
  border: 1px solid var(--color-border-primary);
  /* Shadow/xs */
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
}
.input-text {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--font-primary), sans-serif;
  font-size: 14px;
  color: var(--color-text-primary);
}

.input-text::placeholder {
  color: #a0a3a7;
}
.dec-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  max-width: 592px;
  width:100% ;
  height: 195px;
}
.desc-data {
  width: 77px;
  height: 20px;
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-secondary);
}
.desc-box {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 14px;
  gap: 8px;
  width: 100%;
  max-width:592px;
  height: 169px;
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
}
.desc-text {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  resize: none; /* optional: prevent manual resizing */
  font-family: var(--font-primary), sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: var(--color-text-secondary);
  margin: 0;
  padding: 0;

  white-space: pre-line; /* allow line breaks */
}

/* .choose-type {
  width: 592px;
  height: 70px;
  display: flex;
  flex-direction: column;
  gap: 6px;
} */

.choose-name {
  font-family: var(--font-primary), sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-secondary);
}

.optional-hint {
  font-weight: 400;
  font-size: 12px;
  color: var(--color-text-tertiary);
}

.search-type {
  width: 100%;
  max-width: 592px;
  height: 70px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.search-name {
  font-family: var(--font-primary), sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-secondary);
}

.search-box {
  position: relative;
  max-width: 592px;
  width: 100%; /* EXACT width of your input */
  height: 44px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
}

.suggestion-list {
  position: absolute;
  top: 100%;
  width: 100%;
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  border-radius: 8px;
  max-height: 240px;
  overflow-y: auto;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 6px 0;
  margin-left: -13px;
}
.suggestion-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.search-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.search-text {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--font-primary), sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: var(--color-text-primary);
}

.search-text::placeholder {
  color: var(--color-text-tertiary);
}
.contact-details {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  max-width: 592px;
  width: 100%;
}

.mobile,
.email {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 286px;
}

.mobile-label,
.email-label {
  font-family: var(--font-primary), sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-secondary);
}

.contact-input {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
  /* overflow: visible so the country-code dropdown panel can extend below */
}

.country-code-wrapper {
  position: relative;
  height: 100%;
  flex-shrink: 0;
}
.country-code-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 78px;
  height: 100%;
  padding: 0 10px;
  border: none;
  border-right: 1px solid var(--color-border-light);
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
  background: var(--color-bg-secondary);
  font-family: var(--font-primary), sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-primary);
  cursor: pointer;
  outline: none;
}
.country-code-btn:hover { background: var(--color-bg-tertiary, #f5f5f7); }
.country-code-btn:focus-visible { box-shadow: inset 0 0 0 2px var(--color-accent, #3f51b5); }
.cc-dial { line-height: 1; }
.cc-chevron {
  color: var(--color-text-secondary);
  transition: transform 0.15s ease;
}
.country-code-btn[aria-expanded="true"] .cc-chevron { transform: rotate(180deg); }

.country-code-list {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 50;
  width: 260px;
  max-height: 280px;
  overflow-y: auto;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid var(--color-border-primary, #d0d5dd);
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.12);
  font-family: var(--font-primary), sans-serif;
}
.country-code-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  font-size: 14px;
  color: var(--color-text-primary);
  cursor: pointer;
  white-space: nowrap;
}
.country-code-item:hover { background: #f5f6f8; }
.country-code-item.active {
  background: #eef2ff;
  color: var(--color-accent, #3f51b5);
  font-weight: 600;
}
.cc-item-dial {
  min-width: 48px;
  color: var(--color-text-secondary);
  font-variant-numeric: tabular-nums;
}
.country-code-item.active .cc-item-dial { color: inherit; }
.cc-item-name { flex: 1; overflow: hidden; text-overflow: ellipsis; }

.contact-text {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--font-primary), sans-serif;
  font-size: 14px;
  color: var(--color-text-primary);
  padding: 0 12px;
}

.contact-text::placeholder {
  color: var(--color-text-tertiary);
}

.email-text {
  width: 100%;
  height: 44px;
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
  font-family: var(--font-primary), sans-serif;
  font-size: 14px;
  color: var(--color-text-primary);
  padding: 0 14px;
  outline: none;
}

.email-text::placeholder {
  color: var(--color-text-tertiary);
}

.images-details {
  max-width:592px ;
  width:100% ;
}

.images-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 100%;
   max-width: 592px;
  height: 126px;
  padding: 12px 16px;
  border: 1px solid var(--color-border-primary);
  border-radius: 8px;
  background: var(--color-bg-primary);
  cursor: pointer;
  text-align: center;
}

/* icon */
.upload-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.first-row {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}
.click-text {
  color: #0b5ed7;
  font-weight: 600;
  font-size: 14px;
}

.or-text {
  color: var(--color-text-tertiary);
  font-family: var(--font-primary), sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.hint-text {
  color: var(--color-text-tertiary);
  font-family: var(--font-primary), sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.images-name {
  width: 115px;
  height: 20px;
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-secondary);
}
.suggestion-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  cursor: pointer;
  transition: 0.15s;
}

.suggestion-list li.highlighted {
  background: #f7f7f7;
}

.suggestion-list li.selected {
  font-weight: 600;
  background: #f0fbff;
}

.location-icon {
  font-size: 16px;
  color: #111827;
}

.check-icon {
  margin-left: auto;
  color: #10b981;
}
.images-box.has-images {
  justify-content: flex-start;
}

/* Container for thumbnails */
.preview-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  padding: 6px 4px;
  max-height: 110px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Thumbnail frame */
.thumb {
  position: relative;
  width: 60px;
  height: 60px;
}

/* Image style */
.thumb img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid var(--color-border-primary);
}

.remove-btn {
  position: absolute;
  top: -6px;
  right: -10px;
  width: 0px;
  height: 0px;
  border: none;
 background: transparent;
  color: var(--color-error);
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-more {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  background: #e8e8e8;
  border: 1px dashed #b3b3b3;
}

.images-box.has-images {
  cursor: default !important;
}

@media (max-width: 768px) {
  /* Remove fixed widths that cause swipe issue */
  .container {
    width: 100% !important;
    max-width: 100% !important;
    min-height: 100dvh !important;
    height: auto !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden;
  }

  .header {
    width: 100% !important;
    max-width: 100% !important;
    /* This route renders without the app navbar, so the header must clear the
       notch/status bar itself (env() is 0 in ordinary browsers). */
    height: calc(72px + env(safe-area-inset-top, 0px)) !important;
    padding: env(safe-area-inset-top, 0px) 16px 0 !important;
    flex-shrink: 0;
  }

  .content-area {
    flex-direction: column;
    padding: 0;
    overflow: hidden;
    flex: 1;
    min-height: 0;
    height: calc(100dvh - 72px - env(safe-area-inset-top, 0px)) !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .left-view {
    width: 100% !important;
    max-width: 100% !important;
    /* The header/body/footer column fills the space; only .wizard-body scrolls,
       so the footer buttons stay pinned to the visible bottom edge. */
    overflow: hidden !important;
    flex: 1 1 auto !important;
    min-height: 0 !important;
    height: auto !important;
    max-height: none !important;
    position: relative !important;
    border-width: 0 !important;
    border-radius: 0 !important;
  }

  .wizard-header {
    padding: 14px 16px 10px;
  }

  .wizard-body {
    padding: 16px 14px 20px;
  }

  .wizard-footer {
    padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
  }

  .wizard-footer-right {
    flex: 1;
    justify-content: flex-end;
  }

  .wizard-continue {
    flex: 1;
    max-width: 320px;
    height: 48px;
  }

  .post-initial,
  .NewPost,
  .post-detail,
  .title-section,
  .dec-section {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
  }

  .wizard-title-row .NewPost {
    font-size: 19px !important;
    line-height: 26px !important;
  }

  .post-detail {
    line-height: 22px !important;
    color: var(--color-text-secondary);
  }

  .cat-grid {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  }

  /* Hide the right preview section */
  .right-view,
  RightViewCard {
    display: none !important;
  }

  /* Fix inner sections */
  .title-section,
  .dec-section,
  .choose-type,
  .search-type,
  .contact-details,
  .images-details,
  .images-box {
    width: 100% !important;
    max-width: 100% !important;
  }

  .images-box {
    min-height: 126px;
    height: auto !important;
  }

  /* Make all input boxes full width */
  .input-box,
  .desc-box,
  .choose-box,
  .search-box,
  .email-text,
  .contact-input {
    width: 100% !important;
  }

  /* Contact section becomes vertical */
  .contact-details {
    flex-direction: column;
    gap: 12px;
  }

  .mobile,
  .email {
    width: 100% !important;
  }

  /* Back button stays left */
  .button-bar {
    position: absolute;
    left: 0px;
    width: 50px;
    height: 44px;
    transform: none;
    font-size: 14px;
    z-index: 10;
    border: none;
  }

  /* Logo stays centered */
  .title-bar img {
    left: 50%;
    transform: translateX(-50%);
  }
}

.error-outline {
  border: 1.5px solid var(--color-error) !important;
}

.field-error {
  display: block;
  margin-top: 4px;
  color: var(--color-error);
  font-size: 12px;
  line-height: 1.3;
}

/* Below 600px the fixed bottom tab bar (48px + home-indicator inset) overlays
   the standalone /new-post and /edit-post routes — subtract it so the wizard
   footer (Continue/Post buttons) clears it. Inside PostModal the modal covers
   the bar; PostModal restores the full height via :deep. */
@media (max-width: 600px) {
  .content-area {
    height: calc(
      100dvh - 72px - env(safe-area-inset-top, 0px) - 48px -
        env(safe-area-inset-bottom, 0px)
    ) !important;
  }
}

@media (max-width: 1200px) and (min-width: 769px) {
  .content-area {
    flex-direction: row; /* side by side */
    align-items: stretch;
    justify-content: space-between;
    gap: 20px;
    padding: 16px;
    /* Keep the base calc(100vh - 80px); the modal overrides it via :deep.
       A fixed height here would overflow the popup and clip the footer. */
    overflow: hidden;
    box-sizing: border-box;
  }

  /* Wizard column at 50%, footer stays inside the panel */
  .left-view {
    width: 50%;
    max-width: 50%;
    height: 100%;
    overflow: hidden;
  }

  /* Right view width 50% */
  .right-view {
    width: 50%;
    max-width: 50%;
    display: flex; /* ensure it's visible */
    height: 100%;
    overflow-y: auto;
  }

  RightViewCard {
    display: flex !important;
  }

  /* Form sections full width inside left view */
  .title-section,
  .dec-section,
  .search-type,
  .contact-details,
  .images-details {
    width: 100% !important;
  }

  .input-box,
  .desc-box,
  .search-box,
  .email-text,
  .contact-input,
  .images-box {
    width: 100% !important;
  }

  /* Contact layout */
  .contact-details {
    flex-direction: row;
    gap: 20px;
  }

  .mobile,
  .email {
    width: 100%; /* full width when stacked */
  }

  .post-detail {
    width: 100% !important;
    height: auto;
  }
}
@media (max-width: 1200px) {
  .contact-details {
    flex-direction: column; /* stack vertically */
    gap: 16px; /* smaller gap when stacked */
  }

  .mobile,
  .email {
    width: 100%; /* full width when stacked */
  }
}
</style>
